import {
  type GetSpaceUsageMetricsRequest,
  MonitoringService,
} from '@qdrant/qdrant-cloud-public-api/serverless/monitoring/v1';
import {
  getSpaceSummaryMetrics,
  getSpaceUsageMetrics,
} from '@qdrant/qdrant-cloud-public-api/serverless/monitoring/v1/connect-query';
import { transport } from '@/api/transport';
import { createServiceQueries, type MessageInput, queryOptions } from '@/connect-query';
import { type SpaceIds } from './space';

/**
 * What a usage read is narrowed by: a time range, and one collection or every one. The generated input makes the
 * `collectionFilter` oneof required, so this takes a plain collection name instead.
 */
export type SpaceUsageFilter = Pick<MessageInput<GetSpaceUsageMetricsRequest>, 'since' | 'until'> & {
  collectionName?: string;
};

// Pagination stays unset: the summary reads every collection of the space, the usage the one named or every one.
export const spaceMonitoringService = createServiceQueries(MonitoringService, {
  getSpaceSummaryMetricsQuery: (params: SpaceIds) => queryOptions(getSpaceSummaryMetrics, params, { transport }),
  getSpaceUsageMetricsQuery: ({ collectionName, ...params }: SpaceIds & SpaceUsageFilter) =>
    queryOptions(
      getSpaceUsageMetrics,
      {
        ...params,
        collectionFilter: collectionName ? { case: 'collectionName', value: collectionName } : undefined,
      },
      { transport, select: (data) => data.items },
    ),
});
